<!-- Simplified at icon size and cropped to 4:3 from the hoist side. -->
@switch (language()) {
  @case ('en') {
    <svg viewBox="0 0 640 480">
      <rect width="640" height="480" fill="#012169" />
      <path d="M0 0L640 480M640 0L0 480" stroke="#fff" stroke-width="96" />
      <path d="M0 0L640 480M640 0L0 480" stroke="#c8102e" stroke-width="32" />
      <path d="M320 0V480M0 240H640" stroke="#fff" stroke-width="160" />
      <path d="M320 0V480M0 240H640" stroke="#c8102e" stroke-width="96" />
    </svg>
  }
  @case ('de') {
    <svg viewBox="0 0 640 480">
      <rect width="640" height="160" fill="#000" />
      <rect y="160" width="640" height="160" fill="#d00" />
      <rect y="320" width="640" height="160" fill="#ffce00" />
    </svg>
  }
  @case ('fr') {
    <svg viewBox="0 0 640 480">
      <rect width="214" height="480" fill="#0055a4" />
      <rect x="213" width="214" height="480" fill="#fff" />
      <rect x="426" width="214" height="480" fill="#ef4135" />
    </svg>
  }
  @case ('es') {
    <svg viewBox="0 0 640 480">
      <rect width="640" height="480" fill="#aa151b" />
      <rect y="120" width="640" height="240" fill="#f1bf00" />
    </svg>
  }
  @case ('hu') {
    <svg viewBox="0 0 640 480">
      <rect width="640" height="160" fill="#cd2a3e" />
      <rect y="160" width="640" height="160" fill="#fff" />
      <rect y="320" width="640" height="160" fill="#436f4d" />
    </svg>
  }
  @case ('it') {
    <svg viewBox="0 0 640 480">
      <rect width="214" height="480" fill="#009246" />
      <rect x="213" width="214" height="480" fill="#fff" />
      <rect x="426" width="214" height="480" fill="#ce2b37" />
    </svg>
  }
  @case ('pl') {
    <svg viewBox="0 0 640 480">
      <rect width="640" height="240" fill="#fff" />
      <rect y="240" width="640" height="240" fill="#dc143c" />
    </svg>
  }
  @case ('pt') {
    <svg viewBox="0 0 640 480">
      <rect width="640" height="480" fill="#009c3b" />
      <path d="M54 240L320 48L586 240L320 432Z" fill="#ffdf00" />
      <circle cx="320" cy="240" r="116" fill="#002776" />
    </svg>
  }
  @case ('tr') {
    <svg viewBox="0 0 640 480">
      <rect width="640" height="480" fill="#e30a17" />
      <circle cx="240" cy="240" r="120" fill="#fff" />
      <circle cx="270" cy="240" r="96" fill="#e30a17" />
      <polygon
        fill="#fff"
        points="372,240 413.5,226.5 413.5,182.9 439.1,218.2 480.5,204.7 454.9,240 480.5,275.3 439.1,261.8 413.5,297.1 413.5,253.5" />
    </svg>
  }
  @default {
    <fa-duotone-icon class="automatic-icon" [icon]="faLanguage" />
  }
}
